import React from 'react';
import ReactLoading from 'react-loading';
 
const Loading = () => (
    <ReactLoading className="container-fluid mt-5" type={'spinningBubbles'} color={"#14274e"} height={'10%'} width={'10%'} />
);
 
export default Loading;